import React from "react";
import styles from "./styles.module.less";

export default function RightPanel() {
  return <aside className={styles.panel}></aside>;
}
